<template>
  <div class="show_all_content_wrapper">
    <!-- Start:: Main Section -->
    <main>
      <!--  =========== Start:: Show Modal =========== -->
      <div class="show_content_wrapper">
        <button class="arrow_btn" @click="closeModal">
          <i class="fal fa-long-arrow-left" v-if="getAppLocale == 'ar'"></i>
          <i class="fal fa-long-arrow-right" v-else></i>
        </button>

        <div class="table_title_wrapper">
          <h5>{{ $t("SIDENAV.activities.show") }}</h5>
        </div>

        <div class="table_wrapper">
          <table class="data_table">
            <tbody>
              <!-- Start:: Name AR -->
              <tr>
                <td>{{ $t("PLACEHOLDERS.activity_name_ar") }}</td>
                <td class="fw-bold">
                  {{ data.name_ar ? data.name_ar : "___" }}
                </td>
              </tr>
              <!-- End:: Name AR -->

              <!-- Start:: Name EN -->
              <tr>
                <td>{{ $t("PLACEHOLDERS.activity_name_en") }}</td>
                <td class="fw-bold">
                  {{ data.name_en ? data.name_en : "___" }}
                </td>
              </tr>
              <!-- End:: Name EN -->

              <!-- Start:: Status -->
              <tr>
                <td>{{ $t("PLACEHOLDERS.status") }}</td>
                <td class="fw-bold">
                  <span v-if="data.is_active" class="text-success">{{
                    $t("STATUS.active")
                  }}</span>
                  <span v-else class="text-danger">{{
                    $t("STATUS.notActive")
                  }}</span>
                </td>
              </tr>
              <!-- End:: Status -->

              <!-- Start:: Created At -->
              <tr>
                <td>{{ $t("PLACEHOLDERS.created_at") }}</td>
                <td class="fw-bold">
                  {{ data.created_at ? data.created_at : "___" }}
                </td>
              </tr>
              <!-- End:: Created At -->
            </tbody>
          </table>
        </div>
      </div>
      <!--  =========== End:: Show Modal =========== -->
    </main>
    <!-- End:: Main Section -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ShowActivity",

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),
  },

  data() {
    return {
      // Start:: Data
      data: {
        name_ar: null,
        name_en: null,
        is_active: null,
        created_at: null,
      },
      // End:: Data
    };
  },

  methods: {
    // Start:: Get Data
    async getData() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `activities/${this.$route.params.id}`,
        });
        this.data.name_ar = res.data.data.activity?.name_ar;
        this.data.name_en = res.data.data.activity?.name_en;
        this.data.is_active = res.data.data.activity?.is_active;
        this.data.created_at = res.data.data.activity?.created_at;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    // End:: Get Data

    // Start:: Close Modal
    closeModal() {
      this.$router.push({ path: "/activities/all" });
    },
    // End:: Close Modal
  },

  created() {
    this.getData();
  },
};
</script>

<style scoped lang="scss">
.show_content_wrapper {
  position: relative;
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

  .arrow_btn {
    position: absolute;
    top: 20px;
    right: 20px;
    background-color: #404b3e;
    color: #fff;
    border: none;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
      background-color: #2d3528;
    }

    i {
      font-size: 18px;
    }
  }

  .table_title_wrapper {
    margin-bottom: 30px;

    h5 {
      font-size: 24px;
      font-weight: 600;
      color: #404b3e;
    }
  }

  .table_wrapper {
    .data_table {
      width: 100%;
      border-collapse: collapse;

      tbody {
        tr {
          border-bottom: 1px solid #e0e0e0;

          &:last-child {
            border-bottom: none;
          }

          td {
            padding: 15px 10px;
            font-size: 16px;

            &:first-child {
              color: #666;
              width: 30%;
            }

            &.fw-bold {
              font-weight: 600;
              color: #333;
            }
          }
        }
      }
    }
  }
}
</style>
